var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link"},[_c('router-link',{attrs:{"to":{
      name: 'retainer-details',
      query: {
        companyId: this.$route.query.companyId
          ? this.$route.query.companyId
          : _vm.data.companyId,
        ID:_vm.data.id,
        clientId:_vm.clientId
      },
    },"title":_vm.$t('text.clickButtons.viewDashboard')}},[_c('p',{staticStyle:{"color":"rgb(75, 44, 114)","margin-top":"20px","padding-left":"10px","text-align":"left !important"}},[_vm._v("\n      "+_vm._s(_vm.data.name)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }